import robot from "../../assets/images/robot 10.png";
import classes from "./section_hero.module.css";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";

const SectionHero = () => {
  const storedLang = localStorage.getItem("lang");
  let lng = storedLang ?? navigator.language;
  const { t, i18n } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(lng);
  }, [lng, i18n]);

  return (
    <section className={classes["section-hero"]}>
      <div className={classes.circle}>
        <div className={classes["half-circle"]}></div>
        <div className={classes.hero}>
          <div className={classes["hero-info"]}>
            <h1 className={classes["hero-heading"]}>{t("hero.title")}</h1>
            <p className={classes["hero-description"]}>
              {t("hero.description")}
            </p>
            <a className={classes["hero-btn--link"]} href="#prototype">
              {t("hero.button_text")} &darr;
            </a>
          </div>
          <div className={classes["hero-img"]}>
            <img className={classes["img"]} src={robot} alt="robot" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionHero;
